// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Quiz Section Styles */
.quiz-section {
  padding: 0;
}

/* Loading and Error States */
.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
}

.error-content {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.error-content p {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: white;
}

.no-content {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.no-content p {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: white;
}

.control-button {
  padding: 0.5rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
  background: rgba(31, 41, 55, 0.4);
  color: #fff;
  cursor: pointer;
  transition: background-color 0.15s;
  font-size: 0.875rem;
}

.control-button:hover:not(:disabled) {
  background: rgba(55, 65, 81, 0.5);
}

.control-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Quiz Container */
.quiz-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(31, 41, 55, 0.5);
  border-radius: 0.5rem;
}

.quiz-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
  overflow-y: auto;
}

/* Quiz Header */
.quiz-header {
  text-align: center;
  margin-bottom: 1rem;
  padding: 1rem;
  background: rgba(31, 41, 55, 0.3);
  border-radius: 0.375rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.quiz-header h3 {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.quiz-header p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin: 0;
}

/* All Questions Container */
.all-questions-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 1 1;
}

/* Individual Question Block */
.question-block {
  background: rgba(31, 41, 55, 0.4);
  border-radius: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem;
  transition: all 0.2s ease;
}

.question-block:hover {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(31, 41, 55, 0.5);
}

.question-number {
  display: inline-block;
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.5);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 400;
  border: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 0.75rem;
}

.question-text {
  font-size: 1rem;
  color: #fff;
  line-height: 1.6;
  font-weight: 400;
  margin-bottom: 1.25rem;
}

.question-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 0.5rem;
  padding: 1rem;
  color: rgba(239, 68, 68, 0.9);
  text-align: center;
}

/* Options Container */
.options-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Option Buttons */
.option-button {
  width: 100%;
  padding: 1rem 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  background: rgba(31, 41, 55, 0.4);
  color: #fff;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95rem;
  line-height: 1.5;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.option-button:hover:not(:disabled) {
  background: rgba(55, 65, 81, 0.6);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.option-button.selected {
  background: rgba(59, 130, 246, 0.3);
  border-color: rgba(59, 130, 246, 0.5);
  color: #fff;
}

.option-button.correct {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(34, 197, 94, 0.4);
}

.option-button.incorrect {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.4);
  color: #fff;
}

/* Option Letters (A, B, C, D) */
.option-letter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  font-size: 0.875rem;
  font-weight: 600;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.option-button.selected .option-letter {
  background: rgba(59, 130, 246, 0.5);
  border-color: rgba(59, 130, 246, 0.7);
  color: #fff;
}

.option-button.correct .option-letter {
  background: rgba(34, 197, 94, 0.5);
  border-color: rgba(34, 197, 94, 0.7);
  color: #fff;
}

.option-button.incorrect .option-letter {
  background: rgba(239, 68, 68, 0.5);
  border-color: rgba(239, 68, 68, 0.7);
  color: #fff;
}

/* Show Answer Button */
.show-answer-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.show-answer-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-top: 12px;
}

.show-answer-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.show-answer-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

/* Quiz Submit Container */
.quiz-submit-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: rgba(31, 41, 55, 0.3);
  border-radius: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 1rem;
  position: sticky;
  bottom: 0;
  backdrop-filter: blur(10px);
}

.quiz-progress {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  font-weight: 500;
}

.submit-quiz-button {
  padding: 0.75rem 2rem;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.8), rgba(16, 185, 129, 0.8));
  color: white;
  border: 1px solid rgba(34, 197, 94, 0.5);
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
}

.submit-quiz-button:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.9), rgba(16, 185, 129, 0.9));
  border-color: rgba(34, 197, 94, 0.7);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.submit-quiz-button:disabled {
  background: rgba(107, 114, 128, 0.4);
  border-color: rgba(107, 114, 128, 0.3);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Results View */
.quiz-results {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
  overflow-y: auto;
}

.quiz-score {
  padding: 1.25rem;
  background: rgba(31, 41, 55, 0.4);
  border-radius: 0.375rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.quiz-score h2 {
  font-size: 1.125rem;
  color: #fff;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.quiz-score p {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.6);
}

.quiz-answers {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.quiz-answer-review {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  padding: 1.25rem;
  background: rgba(31, 41, 55, 0.3);
  border-radius: 0.375rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.quiz-answer-review .question-text {
  font-weight: 400;
  font-size: 0.9375rem;
}

.quiz-answer-review .options-container {
  gap: 0.5rem;
}

.quiz-answer-review .option-button {
  cursor: default;
  pointer-events: none;
  padding: 0.75rem 1rem;
}

/* Ask AI Button */
.ask-ai-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.ask-ai-button {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6), rgba(75, 85, 99, 0.6));
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(107, 114, 128, 0.4);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: auto;
  white-space: nowrap;
}

.ask-ai-button:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.8), rgba(75, 85, 99, 0.8));
  border-color: rgba(107, 114, 128, 0.6);
  color: rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.ask-ai-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.loading-spinner-small {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* AI Explanation */
.ai-explanation {
  margin-top: 12px;
  padding: 12px;
  background: rgba(107, 114, 128, 0.1);
  border: 1px solid rgba(107, 114, 128, 0.2);
  border-radius: 8px;
  border-left: 3px solid rgba(107, 114, 128, 0.5);
}

.ai-explanation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8px;
  font-size: 14px;
}

.ai-icon {
  font-size: 16px;
}

.ai-explanation-text {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  font-size: 14px;
  font-style: italic;
}

/* Responsive Design */
@media (max-width: 640px) {
  .quiz-content,
  .quiz-results {
    padding: 1rem;
  }

  .quiz-header {
    padding: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .quiz-header h3 {
    font-size: 1.125rem;
  }

  .question-block {
    padding: 1rem;
  }

  .option-button {
    padding: 0.875rem 1rem;
    font-size: 0.9rem;
  }

  .option-letter {
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.8rem;
  }

  .quiz-submit-container {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .submit-quiz-button {
    width: 100%;
  }

  .all-questions-container {
    gap: 1.5rem;
  }
}

/* Accessibility */
.ask-ai-button:focus,
.submit-quiz-button:focus,
.option-button:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .option-button,
  .submit-quiz-button,
  .question-block {
    transition: none;
  }

  .loading-spinner {
    animation: none;
  }

  .submit-quiz-button:hover:not(:disabled),
  .option-button:hover:not(:disabled) {
    transform: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoTabs/QuizTab.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA,8BAA8B;AAC9B;EACE,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,qBAAqB;EACrB,0CAA0C;EAC1C,qBAAqB;EACrB,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oFAAoF;EACpF,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oFAAoF;EACpF,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,oFAAoF;EACpF,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oFAAoF;EACpF,sCAAsC;EACtC,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kBAAkB;AAClB;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Quiz Section Styles */\n.quiz-section {\n  padding: 0;\n}\n\n/* Loading and Error States */\n.loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.875rem;\n}\n\n.error-content {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n}\n\n.error-content p {\n  font-size: 1.1rem;\n  margin-bottom: 1.5rem;\n  color: white;\n}\n\n.no-content {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n}\n\n.no-content p {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.control-button {\n  padding: 0.5rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 0.375rem;\n  background: rgba(31, 41, 55, 0.4);\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.15s;\n  font-size: 0.875rem;\n}\n\n.control-button:hover:not(:disabled) {\n  background: rgba(55, 65, 81, 0.5);\n}\n\n.control-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Quiz Container */\n.quiz-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: rgba(31, 41, 55, 0.5);\n  border-radius: 0.5rem;\n}\n\n.quiz-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 1.5rem;\n  overflow-y: auto;\n}\n\n/* Quiz Header */\n.quiz-header {\n  text-align: center;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  background: rgba(31, 41, 55, 0.3);\n  border-radius: 0.375rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.quiz-header h3 {\n  color: #fff;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.quiz-header p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* All Questions Container */\n.all-questions-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  flex: 1;\n}\n\n/* Individual Question Block */\n.question-block {\n  background: rgba(31, 41, 55, 0.4);\n  border-radius: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 1.5rem;\n  transition: all 0.2s ease;\n}\n\n.question-block:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(31, 41, 55, 0.5);\n}\n\n.question-number {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.03);\n  color: rgba(255, 255, 255, 0.5);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 400;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  margin-bottom: 0.75rem;\n}\n\n.question-text {\n  font-size: 1rem;\n  color: #fff;\n  line-height: 1.6;\n  font-weight: 400;\n  margin-bottom: 1.25rem;\n}\n\n.question-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 0.5rem;\n  padding: 1rem;\n  color: rgba(239, 68, 68, 0.9);\n  text-align: center;\n}\n\n/* Options Container */\n.options-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n/* Option Buttons */\n.option-button {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 0.5rem;\n  background: rgba(31, 41, 55, 0.4);\n  color: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.option-button:hover:not(:disabled) {\n  background: rgba(55, 65, 81, 0.6);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.option-button.selected {\n  background: rgba(59, 130, 246, 0.3);\n  border-color: rgba(59, 130, 246, 0.5);\n  color: #fff;\n}\n\n.option-button.correct {\n  background: rgba(34, 197, 94, 0.2);\n  border-color: rgba(34, 197, 94, 0.4);\n}\n\n.option-button.incorrect {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #fff;\n}\n\n/* Option Letters (A, B, C, D) */\n.option-letter {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  font-size: 0.875rem;\n  font-weight: 600;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.option-button.selected .option-letter {\n  background: rgba(59, 130, 246, 0.5);\n  border-color: rgba(59, 130, 246, 0.7);\n  color: #fff;\n}\n\n.option-button.correct .option-letter {\n  background: rgba(34, 197, 94, 0.5);\n  border-color: rgba(34, 197, 94, 0.7);\n  color: #fff;\n}\n\n.option-button.incorrect .option-letter {\n  background: rgba(239, 68, 68, 0.5);\n  border-color: rgba(239, 68, 68, 0.7);\n  color: #fff;\n}\n\n/* Show Answer Button */\n.show-answer-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.show-answer-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  margin-top: 12px;\n}\n\n.show-answer-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.show-answer-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Quiz Submit Container */\n.quiz-submit-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background: rgba(31, 41, 55, 0.3);\n  border-radius: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 1rem;\n  position: sticky;\n  bottom: 0;\n  backdrop-filter: blur(10px);\n}\n\n.quiz-progress {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.submit-quiz-button {\n  padding: 0.75rem 2rem;\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.8), rgba(16, 185, 129, 0.8));\n  color: white;\n  border: 1px solid rgba(34, 197, 94, 0.5);\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 140px;\n}\n\n.submit-quiz-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.9), rgba(16, 185, 129, 0.9));\n  border-color: rgba(34, 197, 94, 0.7);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);\n}\n\n.submit-quiz-button:disabled {\n  background: rgba(107, 114, 128, 0.4);\n  border-color: rgba(107, 114, 128, 0.3);\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Results View */\n.quiz-results {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 1.5rem;\n  overflow-y: auto;\n}\n\n.quiz-score {\n  padding: 1.25rem;\n  background: rgba(31, 41, 55, 0.4);\n  border-radius: 0.375rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  text-align: center;\n}\n\n.quiz-score h2 {\n  font-size: 1.125rem;\n  color: #fff;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.quiz-score p {\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.quiz-answers {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.quiz-answer-review {\n  display: flex;\n  flex-direction: column;\n  gap: 0.875rem;\n  padding: 1.25rem;\n  background: rgba(31, 41, 55, 0.3);\n  border-radius: 0.375rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.quiz-answer-review .question-text {\n  font-weight: 400;\n  font-size: 0.9375rem;\n}\n\n.quiz-answer-review .options-container {\n  gap: 0.5rem;\n}\n\n.quiz-answer-review .option-button {\n  cursor: default;\n  pointer-events: none;\n  padding: 0.75rem 1rem;\n}\n\n/* Ask AI Button */\n.ask-ai-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.ask-ai-button {\n  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6), rgba(75, 85, 99, 0.6));\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(107, 114, 128, 0.4);\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: auto;\n  white-space: nowrap;\n}\n\n.ask-ai-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, rgba(107, 114, 128, 0.8), rgba(75, 85, 99, 0.8));\n  border-color: rgba(107, 114, 128, 0.6);\n  color: rgba(255, 255, 255, 0.95);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.ask-ai-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.loading-spinner-small {\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* AI Explanation */\n.ai-explanation {\n  margin-top: 12px;\n  padding: 12px;\n  background: rgba(107, 114, 128, 0.1);\n  border: 1px solid rgba(107, 114, 128, 0.2);\n  border-radius: 8px;\n  border-left: 3px solid rgba(107, 114, 128, 0.5);\n}\n\n.ai-explanation-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.ai-icon {\n  font-size: 16px;\n}\n\n.ai-explanation-text {\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.5;\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .quiz-content,\n  .quiz-results {\n    padding: 1rem;\n  }\n\n  .quiz-header {\n    padding: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .quiz-header h3 {\n    font-size: 1.125rem;\n  }\n\n  .question-block {\n    padding: 1rem;\n  }\n\n  .option-button {\n    padding: 0.875rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  .option-letter {\n    width: 1.5rem;\n    height: 1.5rem;\n    font-size: 0.8rem;\n  }\n\n  .quiz-submit-container {\n    padding: 1rem;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .submit-quiz-button {\n    width: 100%;\n  }\n\n  .all-questions-container {\n    gap: 1.5rem;\n  }\n}\n\n/* Accessibility */\n.ask-ai-button:focus,\n.submit-quiz-button:focus,\n.option-button:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .option-button,\n  .submit-quiz-button,\n  .question-block {\n    transition: none;\n  }\n\n  .loading-spinner {\n    animation: none;\n  }\n\n  .submit-quiz-button:hover:not(:disabled),\n  .option-button:hover:not(:disabled) {\n    transform: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
